import React from 'react'
import { Link } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const ResetPasswordForm = ({ handleInput, formData, loading, password_error, setPassword_error }) => {
  return (
     <>
      <InputGroup
        componentType="password" 
        label="New Password"
        name="password"
        type="password"
        required={true}
        placeholder={'Enter your New Password'}
        value={formData.password}
        autoComplete="new-password"
        onChange={handleInput}
        error={password_error}
        seterror={setPassword_error}
      />
      <InputGroup
        componentType="password" 
        label="Confirm Password"
        name="confirm_password"
        type="password"
        required={true}
        placeholder={'Confirm your New Password'}
        value={formData.confirm_password}
        autoComplete="new-password"
        onChange={handleInput}
        error={password_error}
        seterror={setPassword_error}
      />
      <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
      >
        Change Password
      </Button>
      <footer>
        <p>
          Remember your password? <Link to="/auth/sign-in">Log in</Link>
        </p>
      </footer>
    </>
  )
}

export default ResetPasswordForm
